










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import Monitoring24JamIcuSvc from "@/services/Monitoring24JamIcu";
import { storeMonitoring24JamIcu } from "@/store/modules/Monitoring24JamIcuStore";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import { storeDokter } from "@/store/modules/dokter";
import Monitoring24JamIcuHourlyDialog from "@/components/pemeriksaan/icu-hcu/Monitoring24JamIcuHourlyDialog.vue";
import Monitoring24JamIcuTtvImportDialog from "@/components/pemeriksaan/icu-hcu/Monitoring24JamIcuTtvImportDialog.vue";
import Monitoring24JamIcuBalanceShiftView from "@/components/pemeriksaan/icu-hcu/Monitoring24JamIcuBalanceShiftView.vue";
import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";
import ObatComboField from "@/components/pemeriksaan/resep-obat/lembar-permintaan/ObatComboField.vue";
import SectionCard from "@/components/pemeriksaan/icu-hcu/Monitoring24JamIcuSectionCard.vue";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import EncounterIndexStore from "@/store/modules/EncounterIndex";
import AsesmenRisikoJatuh from "@/services/AsesmenRisikoJatuh";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { ALAT_TERPASANG_OPTIONS } from "@/constants/alatTerpasangOptions";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";

const GCS_NT = "NT";

const JAM_CARRIER = moment().format("YYYY-MM-DD");

const JENIS_CAIRAN_SUGGESTIONS = [
  "RL",
  "NaCl 0.9%",
  "D5%",
  "D10%",
  "Aminofluid",
  "Albumin",
  "PRC",
  "ASI / Susu Formula",
  "Air Putih"
];

@Component({
  components: {
    PersonAutoComplete,
    Monitoring24JamIcuHourlyDialog,
    Monitoring24JamIcuTtvImportDialog,
    Monitoring24JamIcuBalanceShiftView,
    ConfirmDialog,
    ObatComboField,
    SectionCard,
    VCDateTimePicker
  },
  inject: {
    isReadOnly: { default: () => () => false },
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class Monitoring24JamIcuPage extends Vue {
  @Prop() register!: any;
  @Prop() rm!: any;
  @Prop({ default: false }) isActive!: boolean;
  isReadOnly!: () => boolean;
  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("monitoring_24jam_intensif", "create");
  }

  get canEditForm(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("monitoring_24jam_intensif", "edit");
  }

  selectedDate: string = moment().format("YYYY-MM-DD");
  loading = false;
  saving = false;
  verifying = false;
  deletingForm = false;
  dlgHapusForm = false;
  msgHapusForm = "";

  // Header form (parent fields)
  header: any = this.defaultHeader();

  // Diagnosis 8 slots
  diagnosisArr: string[] = ["", "", "", "", "", "", "", ""];
  diagnosisPrefillDari: string | null = null;

  // Hourly dialog
  dlgHourly = false;
  editingHourly: any = null;

  // Dialog impor Monitor TTV
  dlgTtvImport = false;

  // Generate SMF dari dokter raber
  generatingSmf = false;

  generatingMorse = false;

  // Balance cairan dialog
  dlgBalance = false;
  savingBalance = false;
  deletingBalance = false;
  editingBalance: any = null;
  balanceForm: any = {
    arah: "masuk",
    waktu: null,
    jalur: null,
    jenis_cairan: null,
    jumlah: null
  };
  jalurSearch = "";
  jenisCairanSearch = "";

  // Obat dialog
  dlgObat = false;
  savingObat = false;
  importingObat = false;
  editingObat: any = null;
  obatForm: any = {};
  menuJamPemberian = false;
  jamPemberianInput: string | null = "";
  jamPemberianChips: string[] = [];

  // Instruksi dialog
  dlgInstruksi = false;
  savingInstruksi = false;
  editingInstruksi: any = null;
  instruksiForm: any = {};

  kategoriObatOptions = [
    { text: "Injeksi / Parenteral", value: "injeksi" },
    { text: "Oral / Enteral", value: "oral" },
    { text: "Lain-lain", value: "lain" }
  ];

  caraPemberianItems = [
    { header: "Injeksi / Parenteral" },
    "IV",
    "IV Drip",
    "IM",
    "SC",
    "Syringe Pump",
    { header: "Oral / Enteral" },
    "PO (Oral)",
    "NGT",
    "Sublingual",
    { header: "Lain-lain" },
    "Inhalasi",
    "Rektal",
    "Topikal",
    "Tetes Mata"
  ];

  // Parameter definitions
  hemoParams = [
    { label: "MAP (mmHg)", field: "map" },
    { label: "Sistolik (mmHg)", field: "td_sistole" },
    { label: "Diastolik (mmHg)", field: "td_diastole" },
    { label: "HR (x/mnt)", field: "hr" },
    { label: "Temp (°C)", field: "temp" },
    { label: "Kesadaran", field: "kesadaran" },
    { label: "Irama EKG", field: "irama_ekg" },
    { label: "Skor Nyeri", field: "skor_nyeri" },
    { label: "Skor Sedasi", field: "skor_sedasi" },
    { label: "CVP / RA", field: "cvp_ra" },
    { label: "PAP / LAP", field: "pap_lap" },
    { label: "SpO2 (%)", field: "spo2" },
    { label: "TPM : HR", field: "tpm_hr" }
  ];

  respParams = [
    { label: "Tipe Ventilasi", field: "tipe_ventilasi" },
    { label: "FiO2 (%)", field: "fio2" },
    { label: "Flow (lt/m)", field: "flow" },
    { label: "ROX", field: "rox" },
    { label: "RR (x/mnt)", field: "rr" },
    { label: "VTE (mL)", field: "vte" },
    { label: "PIP / P Platau", field: "pip_p_platau" },
    { label: "PEEP / CPAP", field: "peep_cpap" },
    { label: "Menit Volume", field: "menit_volume" },
    { label: "Perubahan Ventilasi", field: "pola_ventilasi" }
  ];

  neuroParams = [
    { label: "Ukuran Pupil R (mm)", field: "pupil_r_ukuran" },
    { label: "Ukuran Pupil L (mm)", field: "pupil_l_ukuran" },
    { label: "Reaksi Cahaya R", field: "pupil_r_reaksi" },
    { label: "Reaksi Cahaya L", field: "pupil_l_reaksi" },
    { label: "Refleks Tangan Kanan", field: "refleks_tangan_kanan" },
    { label: "Refleks Tangan Kiri", field: "refleks_tangan_kiri" },
    { label: "Refleks Kaki Kanan", field: "refleks_kaki_kanan" },
    { label: "Refleks Kaki Kiri", field: "refleks_kaki_kiri" }
  ];

  neuroGcsParams = [
    { label: "E (Eye)", field: "gcs_e" },
    { label: "V (Verbal)", field: "gcs_v" },
    { label: "M (Motorik)", field: "gcs_m" },
    { label: "Total", field: "gcs_total" }
  ];

  // Tiap angka diberi keterangan kondisi (feedback Tim IRI 2026-07 —
  // mengikuti pola L. Risiko Jatuh)
  comfortItems: any = {
    kewaspadaan: {
      label: "Kewaspadaan",
      items: [
        { text: "1 — Tidur pulas / nyenyak", value: 1 },
        { text: "2 — Tidur kurang nyenyak", value: 2 },
        { text: "3 — Gelisah / mengantuk", value: 3 },
        { text: "4 — Sadar penuh dan waspada", value: 4 },
        { text: "5 — Sangat waspada (hiper-alert)", value: 5 }
      ]
    },
    ketenangan: {
      label: "Ketenangan",
      items: [
        { text: "1 — Tenang", value: 1 },
        { text: "2 — Sedikit cemas", value: 2 },
        { text: "3 — Cemas", value: 3 },
        { text: "4 — Sangat cemas", value: 4 },
        { text: "5 — Panik", value: 5 }
      ]
    },
    distres_pernafasan: {
      label: "Distres Pernafasan",
      items: [
        { text: "1 — Tidak batuk, tidak ada nafas spontan", value: 1 },
        { text: "2 — Nafas spontan, sedikit/tanpa respons ventilator", value: 2 },
        { text: "3 — Kadang batuk / sedikit melawan ventilator", value: 3 },
        { text: "4 — Bernafas aktif melawan ventilator / batuk teratur", value: 4 },
        { text: "5 — Melawan ventilator, batuk/tersedak terus", value: 5 }
      ]
    },
    menangis: {
      label: "Menangis",
      items: [
        { text: "1 — Bernafas tenang, tidak menangis", value: 1 },
        { text: "2 — Terisak-isak / sesekali merintih", value: 2 },
        { text: "3 — Merintih / meraung (monoton)", value: 3 },
        { text: "4 — Menangis", value: 4 },
        { text: "5 — Menangis kuat / berteriak", value: 5 }
      ]
    },
    gerakan: {
      label: "Gerakan (Fisik)",
      items: [
        { text: "1 — Tidak ada gerakan", value: 1 },
        { text: "2 — Gerakan ringan sesekali (≤3x)", value: 2 },
        { text: "3 — Gerakan ringan sering (>3x)", value: 3 },
        { text: "4 — Gerakan kuat terbatas pada ekstremitas", value: 4 },
        { text: "5 — Gerakan kuat termasuk badan dan kepala", value: 5 }
      ]
    },
    tonus_otot: {
      label: "Tonus Otot",
      items: [
        { text: "1 — Otot relaksasi total, tidak ada tonus", value: 1 },
        { text: "2 — Tonus otot menurun", value: 2 },
        { text: "3 — Tonus otot normal", value: 3 },
        { text: "4 — Tonus meningkat, fleksi jari tangan/kaki", value: 4 },
        { text: "5 — Kekakuan otot ekstrem, fleksi jari", value: 5 }
      ]
    },
    tegangan_wajah: {
      label: "Tegangan Wajah",
      items: [
        { text: "1 — Otot wajah relaksasi total", value: 1 },
        { text: "2 — Tonus wajah normal, tanpa tegangan", value: 2 },
        { text: "3 — Tegangan pada beberapa otot wajah", value: 3 },
        { text: "4 — Tegangan hampir seluruh otot wajah", value: 4 },
        { text: "5 — Seluruh otot wajah tegang / meringis", value: 5 }
      ]
    },
    tekanan_darah_basal: {
      label: "TD (MAP) vs Basal",
      items: [
        { text: "1 — TD di bawah basal", value: 1 },
        { text: "2 — TD konsisten pada basal", value: 2 },
        { text: "3 — Kenaikan ≥15% sesekali (1–3x)", value: 3 },
        { text: "4 — Kenaikan ≥15% sering (>3x)", value: 4 },
        { text: "5 — Kenaikan ≥15% menetap", value: 5 }
      ]
    },
    denyut_jantung_basal: {
      label: "HR vs Basal",
      items: [
        { text: "1 — HR di bawah basal", value: 1 },
        { text: "2 — HR konsisten pada basal", value: 2 },
        { text: "3 — Kenaikan ≥15% sesekali (1–3x)", value: 3 },
        { text: "4 — Kenaikan ≥15% sering (>3x)", value: 4 },
        { text: "5 — Kenaikan ≥15% menetap", value: 5 }
      ]
    }
  };

  bradenItems: any = {
    persepsi: {
      label: "Persepsi Sensori",
      items: [
        { text: "1 — Keterbatasan total (tak respons nyeri)", value: 1 },
        { text: "2 — Sangat terbatas (respons hanya nyeri)", value: 2 },
        { text: "3 — Sedikit terbatas (respons perintah verbal)", value: 3 },
        { text: "4 — Tidak ada gangguan", value: 4 }
      ]
    },
    kelembaban: {
      label: "Kelembaban",
      items: [
        { text: "1 — Kulit selalu lembab", value: 1 },
        { text: "2 — Kulit sangat/umumnya lembab", value: 2 },
        { text: "3 — Kulit kadang lembab", value: 3 },
        { text: "4 — Kulit jarang lembab / kering", value: 4 }
      ]
    },
    aktivitas: {
      label: "Aktivitas",
      items: [
        { text: "1 — Tirah baring total (bedfast)", value: 1 },
        { text: "2 — Terbatas di kursi (chairfast)", value: 2 },
        { text: "3 — Kadang berjalan jarak pendek", value: 3 },
        { text: "4 — Sering berjalan", value: 4 }
      ]
    },
    mobilitas: {
      label: "Mobilitas",
      items: [
        { text: "1 — Imobil total (tanpa bantuan)", value: 1 },
        { text: "2 — Sangat terbatas (perubahan posisi minimal)", value: 2 },
        { text: "3 — Sedikit terbatas (sering ubah posisi mandiri)", value: 3 },
        { text: "4 — Tidak ada keterbatasan", value: 4 }
      ]
    },
    nutrisi: {
      label: "Nutrisi",
      items: [
        { text: "1 — Sangat buruk (< ⅓ porsi)", value: 1 },
        { text: "2 — Kemungkinan tidak adekuat (± ½ porsi)", value: 2 },
        { text: "3 — Adekuat (> ½ porsi / nutrisi enteral cukup)", value: 3 },
        { text: "4 — Sangat baik (porsi habis)", value: 4 }
      ]
    },
    gesekan: {
      label: "Gesekan & Cubitan",
      items: [
        { text: "1 — Bermasalah (perlu bantuan penuh, sering merosot)", value: 1 },
        { text: "2 — Berpotensi bermasalah (perlu bantuan minimal)", value: 2 },
        { text: "3 — Tidak ada masalah (mandiri, posisi baik)", value: 3 }
      ]
    }
  };

  morseItems: any = {
    riwayat: {
      label: "Riwayat Jatuh",
      items: [
        { text: "Tidak (0)", value: 0 },
        { text: "Ya (25)", value: 25 }
      ]
    },
    kondisi: {
      label: "Kondisi Kesehatan (diagnosa lain)",
      items: [
        { text: "Tidak (0)", value: 0 },
        { text: "Ya (15)", value: 15 }
      ]
    },
    bantuan_ambulansi: {
      label: "Bantuan Ambulansi",
      items: [
        { text: "Tanpa bantuan (0)", value: 0 },
        { text: "Kruk/tongkat (15)", value: 15 },
        { text: "Furniture (30)", value: 30 }
      ]
    },
    terapi_iv: {
      label: "Terapi IV / Antikoagulan",
      items: [
        { text: "Tidak (0)", value: 0 },
        { text: "Ya (20)", value: 20 }
      ]
    },
    gaya_berjalan: {
      label: "Gaya Berjalan",
      items: [
        { text: "Normal/bedrest (0)", value: 0 },
        { text: "Lemah (10)", value: 10 },
        { text: "Terganggu (20)", value: 20 }
      ]
    },
    status_mental: {
      label: "Status Mental",
      items: [
        { text: "Orientasi baik (0)", value: 0 },
        { text: "Lupa keterbatasan (15)", value: 15 }
      ]
    }
  };

  masukItems = {
    enteral: "Enteral",
    parenteral: "Parenteral",
    ngt: "NGT",
    line_1: "Line 1",
    line_2: "Line 2",
    line_3: "Line 3",
    line_4: "Line 4"
  };

  keluarItems = {
    urine: "Urine",
    ngt: "NGT",
    lokea: "Lokea",
    muntah: "Muntah",
    drain: "Drain",
    uf: "UF (Ultrafiltrasi)",
    fungsi: "Pungsi",
    bab: "BAB",
    iwl: "IWL"
  };

  headersObat = [
    { text: "No", value: "_no", sortable: false, width: "40px" },
    { text: "Nama Obat", value: "nama_obat", width: "20%" },
    { text: "Dosis", value: "dosis", width: "10%" },
    { text: "Rute / Cara", value: "cara_pemberian", width: "9%" },
    { text: "Jadwal (Jam)", value: "jam_pemberian", width: "12%" },
    { text: "TPM", value: "cc_jam", width: "7%" },
    { text: "Tgl Mulai", value: "tgl_mulai", width: "9%" },
    { text: "Tgl Stop", value: "tgl_stop", width: "9%" },
    { text: "Keterangan", value: "keterangan" },
    { text: "", value: "actions", sortable: false, width: "80px" }
  ];

  alatTerpasangOptions = ALAT_TERPASANG_OPTIONS;

  headersAlat = [
    { text: "Jenis Alat", value: "jenis" },
    { text: "Ukuran", value: "ukuran" },
    { text: "Lokasi", value: "lokasi" },
    { text: "Tgl Pasang", value: "tgl_pasang" },
    { text: "Hari ke-", value: "hari_ke" },
    { text: "", value: "actions", sortable: false, width: "50px" }
  ];

  headersLuka = [
    { text: "Lokasi / Jenis", value: "lokasi", width: "30%" },
    { text: "Deskripsi", value: "deskripsi" },
    { text: "", value: "actions", sortable: false, width: "50px" }
  ];

  headersInstruksi = [
    { text: "Instruksi", value: "instruksi" },
    { text: "Jam", value: "jam", width: "80px" },
    { text: "Hasil / Keterangan", value: "hasil" },
    { text: "", value: "actions", sortable: false, width: "80px" }
  ];

  hintJam =
    "Satu form untuk E/F/G — Hemodinamik, Respirasi, dan Neuro disimpan sekali klik pada waktu yang sama. Klik kolom waktu untuk edit.";

  // ================= COMPUTED =================

  get current() {
    return storeMonitoring24JamIcu.current;
  }

  get list() {
    return storeMonitoring24JamIcu.list;
  }

  get sortedHourly(): any[] {
    if (!this.current || !this.current.hourly) return [];
    // slice(): jangan mutasi array store (reaktivitas Vue 2)
    return this.current.hourly
      .slice()
      .sort(
        (a: any, b: any) =>
          this.shiftMinutes(a) - this.shiftMinutes(b) || a.id - b.id
      );
  }

  get hemoEntries(): any[] {
    return this.entriesForSection(this.hemoParams);
  }

  get respEntries(): any[] {
    return this.entriesForSection(this.respParams);
  }

  get neuroEntries(): any[] {
    return this.entriesForSection([...this.neuroParams, ...this.neuroGcsParams]);
  }

  // ===== Balance cairan (entri per-waktu, jalur dinamis) =====

  get sortedBalance(): any[] {
    if (!this.current || !this.current.balance) return [];
    return this.current.balance
      .slice()
      .sort(
        (a: any, b: any) =>
          this.shiftMinutes(a) - this.shiftMinutes(b) || a.id - b.id
      );
  }

  get masukBalanceEntries(): any[] {
    return this.sortedBalance.filter((b: any) => b.arah === "masuk");
  }

  get keluarBalanceEntries(): any[] {
    return this.sortedBalance.filter((b: any) => b.arah === "keluar");
  }

  get totalMasukBalance(): number {
    return this.sumJumlah(this.masukBalanceEntries);
  }

  get totalKeluarBalance(): number {
    return this.sumJumlah(this.keluarBalanceEntries);
  }

  get bc24Computed(): number {
    return this.totalMasukBalance - this.totalKeluarBalance;
  }

  get bcSebelumnyaTerkait(): boolean {
    const bs = this.current && this.current.balance_summary;
    return !!(bs && bs.has_prior);
  }

  get bcSebelumnyaDerived(): number {
    const bs = this.current && this.current.balance_summary;
    return bs ? Number(bs.bc_sebelumnya) || 0 : 0;
  }

  get bcKumulatifComputed(): number {
    const sebelumnya = this.bcSebelumnyaTerkait
      ? this.bcSebelumnyaDerived
      : Number(this.header.balance_cairan.bc_sebelumnya) || 0;
    return this.bc24Computed + sebelumnya;
  }

  get hasLegacyBalance(): boolean {
    // Hanya cek key rincian lama (bukan total/bc_*) — server menulis total
    // ke JSON untuk form baru, itu tidak boleh memicu blok legacy
    return (
      this.legacyBalanceText("masuk") !== "" ||
      this.legacyBalanceText("keluar") !== ""
    );
  }

  get jalurSuggestions(): string[] {
    const isKeluar = this.balanceForm.arah === "keluar";
    const existing = this.distinctJalur(
      isKeluar ? this.keluarBalanceEntries : this.masukBalanceEntries
    );
    const defaults = Object.keys(isKeluar ? this.keluarItems : this.masukItems).map(
      (k: string) => (isKeluar ? (this.keluarItems as any)[k] : (this.masukItems as any)[k])
    );
    const out = existing.slice();
    for (const d of defaults) {
      if (out.indexOf(d) === -1) out.push(d);
    }
    return out;
  }

  get jenisCairanSuggestions(): string[] {
    const out: string[] = [];
    for (const e of this.sortedBalance) {
      const j = String(e.jenis_cairan || "").trim();
      if (j && out.indexOf(j) === -1) out.push(j);
    }
    for (const d of JENIS_CAIRAN_SUGGESTIONS) {
      if (out.indexOf(d) === -1) out.push(d);
    }
    return out;
  }

  get umurText() {
    if (!this.current || !this.current.pasien || !this.current.pasien.tgl_lahir)
      return "-";
    const tgl = this.current.pasien.tgl_lahir;
    // tgl_lahir bisa berformat DD-MM-YYYY — parse eksplisit agar umur tidak NaN
    const m = moment(tgl, ["YYYY-MM-DD", "DD-MM-YYYY"]);
    if (!m.isValid()) return String(tgl);
    return `${tgl} (${moment().diff(m, "years")} th)`;
  }

  get imtText() {
    const tb = Number(this.header.tinggi_badan);
    const bb = Number(this.header.berat_badan);
    if (!tb || !bb || tb <= 0 || bb <= 0) return "-";
    const m = tb / 100;
    return (bb / (m * m)).toFixed(1);
  }

  get bradenBadge() {
    const t = this.header.braden_scale.total || 0;
    if (!t) return { label: "-", color: "grey" };
    if (t >= 19) return { label: "Tidak ada risiko", color: "success" };
    if (t >= 15) return { label: "Risiko rendah", color: "success" };
    if (t >= 13) return { label: "Risiko sedang", color: "warning" };
    if (t >= 10) return { label: "Risiko tinggi", color: "error" };
    return { label: "Risiko sangat tinggi", color: "error" };
  }

  get bradenColor() {
    return this.bradenBadge.color === "error" ? "red lighten-5" : "";
  }

  get morseBadge() {
    const t = this.header.risiko_jatuh.total || 0;
    if (!t) return { label: "-", color: "grey" };
    if (t <= 24) return { label: "Risiko rendah", color: "success" };
    if (t <= 50) return { label: "Risiko sedang", color: "warning" };
    return { label: "Risiko tinggi", color: "error" };
  }

  get morseColor() {
    return this.morseBadge.color === "error" ? "red lighten-5" : "";
  }

  // ================= LIFECYCLE =================

  mounted() {
    if (this.isActive) this.loadAll();
    if (!storeDokter.list.length) storeDokter.act_dokter_all();
  }

  get listDokter() {
    return storeDokter.list;
  }

  onSmfChange() {
    // Sinkron teks SMF (nama tergabung) agar PDF/legacy tetap menampilkan nama.
    const ids = this.header.smf_terkait_ids || [];
    const names = this.listDokter
      .filter((d: any) => ids.includes(d.id))
      .map((d: any) => d.nama);
    this.header.smf_terkait = names.join(", ");
  }

  namaSmf(ids: number[]): string {
    return this.listDokter
      .filter((d: any) => ids.indexOf(Number(d.id)) !== -1)
      .map((d: any) => d.nama)
      .join(", ");
  }

  async ensureEncounterLoaded() {
    if (!EncounterIndexStore.encRanap && this.registerNo) {
      // encounter index bisa belum ada — generate raber jadi no-op
      await EncounterIndexStore.getEncounterRanap(this.registerNo).catch(
        () => undefined
      );
    }
  }

  raberDoctorIds(): number[] {
    const enc: any = EncounterIndexStore.encRanap;
    const parts = enc && Array.isArray(enc.participants) ? enc.participants : [];
    const out: number[] = [];
    for (const p of parts) {
      if (p && p.role === "raber") {
        const id = Number(p.user_id);
        if (id && out.indexOf(id) === -1) out.push(id);
      }
    }
    return out;
  }

  async generateSmfDariRaber() {
    if (this.readOnly) return;
    this.generatingSmf = true;
    try {
      await this.ensureEncounterLoaded();
      const raber = this.raberDoctorIds();
      if (!raber.length) {
        appModule.NoticeDelay("Tidak ada dokter raber terdaftar untuk pasien ini");
        return;
      }
      const ids: number[] = (Array.isArray(this.header.smf_terkait_ids)
        ? this.header.smf_terkait_ids
        : []
      )
        .map(Number)
        .filter(Boolean);
      let added = 0;
      for (const id of raber) {
        if (ids.indexOf(id) === -1) {
          ids.push(id);
          added++;
        }
      }
      this.header.smf_terkait_ids = ids;
      this.onSmfChange();
      this.header = { ...this.header };
      appModule.NoticeDelay(
        added > 0
          ? `${added} dokter raber ditambahkan ke SMF Terkait — jangan lupa Simpan Header`
          : "Semua dokter raber sudah ada di SMF Terkait"
      );
    } finally {
      this.generatingSmf = false;
    }
  }

  morseGroupKey: Record<number, string> = {
    2: "riwayat",
    3: "kondisi",
    4: "bantuan_ambulansi",
    5: "terapi_iv",
    6: "gaya_berjalan",
    7: "status_mental"
  };

  async generateMorseDariAsesmen() {
    if (this.readOnly || !this.registerNo) return;
    this.generatingMorse = true;
    try {
      const resp = await AsesmenRisikoJatuh.getByRegister(
        this.registerNo
      ).catch(() => null);
      if (!resp) return;
      const list: any[] = Array.isArray(resp.data) ? resp.data : [];
      const asesmen = list
        .filter(
          (r: any) =>
            r &&
            r.metode === "mfs" &&
            Array.isArray(r.question) &&
            r.question.length > 0 &&
            r.waktu_periksa &&
            moment(r.waktu_periksa).format("YYYY-MM-DD") <= this.selectedDate
        )
        .sort((a: any, b: any) =>
          String(b.waktu_periksa).localeCompare(String(a.waktu_periksa))
        )[0];
      if (!asesmen) {
        appModule.NoticeDelay(
          `Belum ada Asesmen Risiko Jatuh (Morse) sampai tanggal ${moment(
            this.selectedDate
          ).format("DD-MM-YYYY")}`
        );
        return;
      }
      const rj: any = { ...this.header.risiko_jatuh };
      for (const k of Object.keys(this.morseItems)) rj[k] = null;
      for (const q of asesmen.question) {
        const key = this.morseGroupKey[Number(q.ref_group_id)];
        if (!key) continue;
        const skor = Number(q.skor);
        const valid = this.morseItems[key].items.some(
          (it: any) => it.value === skor
        );
        if (valid) rj[key] = skor;
      }
      this.header.risiko_jatuh = rj;
      this.recalcMorse();
      appModule.NoticeDelay(
        `Risiko jatuh diisi dari Asesmen Risiko Jatuh ${moment(
          asesmen.waktu_periksa
        ).format("DD-MM-YYYY HH:mm")} — jangan lupa Simpan Header`
      );
    } finally {
      this.generatingMorse = false;
    }
  }

  @Watch("isActive")
  onActive(val: boolean) {
    if (val) this.loadAll();
  }

  @Watch("register", { deep: true })
  onRegisterChange() {
    if (this.isActive) this.loadAll();
  }

  // ================= DATA LOADING =================

  async loadAll() {
    if (!this.registerNo) return;
    this.loading = true;
    await storeMonitoring24JamIcu.fetchByRegister(this.registerNo);
    await storeMonitoring24JamIcu.fetchByDate({
      reg: this.registerNo,
      tanggal: this.selectedDate
    });
    this.syncHeaderFromCurrent();
    this.loading = false;
  }

  get registerNo() {
    if (!this.register) return null;
    return typeof this.register === "object"
      ? this.register.no || this.register.register_id
      : this.register;
  }

  get pasienRm() {
    if (this.rm) return this.rm;
    if (this.register && typeof this.register === "object")
      return this.register.cm || this.register.pasien_rm;
    return null;
  }

  dateCache = new Map<string, Date>();

  setTanggal(obj: Record<string, unknown>, key: string, val: Date | null) {
    this.$set(obj, key, toDateString(val));
  }

  setJam(obj: Record<string, unknown>, key: string, val: Date | null) {
    this.$set(obj, key, toTimeString(val) || null);
  }

  dateFromString(val: unknown): Date | null {
    const tgl = typeof val === "string" ? val.slice(0, 10) : "";
    if (!tgl) return null;
    const cached = this.dateCache.get(tgl);
    if (cached) return cached;
    const d = composeDate(tgl);
    if (!d) return null;
    this.dateCache.set(tgl, d);
    return d;
  }

  timeFromString(val: unknown): Date | null {
    const jam = typeof val === "string" ? val.trim().slice(0, 5) : "";
    if (!jam) return null;
    const key = `t:${jam}`;
    const cached = this.dateCache.get(key);
    if (cached) return cached;
    const d = composeDate(JAM_CARRIER, jam);
    if (!d) return null;
    this.dateCache.set(key, d);
    return d;
  }

  get selectedDateModel(): Date | null {
    return this.dateFromString(this.selectedDate);
  }

  set selectedDateModel(val: Date | null) {
    const tgl = toDateString(val);
    if (!tgl || tgl === this.selectedDate) return;
    this.onDateChange(tgl);
  }

  async onDateChange(val: string) {
    this.selectedDate = val;
    await storeMonitoring24JamIcu.fetchByDate({
      reg: this.registerNo,
      tanggal: val
    });
    const c = storeMonitoring24JamIcu.current;
    const dxKosong =
      !c ||
      !Array.isArray(c.diagnosis) ||
      !c.diagnosis.some((v: string) => (v || "").trim());
    if (c && dxKosong) {
      await storeMonitoring24JamIcu.fetchByRegister(this.registerNo);
    }
    this.syncHeaderFromCurrent();
  }

  async loadDate(tgl: string) {
    this.selectedDate = tgl;
    await this.onDateChange(tgl);
  }

  async createNew() {
    if (this.readOnly) return;
    if (!this.registerNo || !this.pasienRm) {
      appModule.NoticeDelay("Register atau RM pasien tidak tersedia");
      return;
    }
    this.loading = true;
    try {
      // Refresh list dulu — previousDayRecord() membaca this.list yang bisa
      // stale (bc_kumulatif ditulis server saat entri balance berubah)
      await storeMonitoring24JamIcu.fetchByRegister(this.registerNo);
      const payload: any = {
        register_id: this.registerNo,
        pasien_rm: this.pasienRm,
        unit_id: this.unitId,
        tanggal: this.selectedDate,
        hari_rawat_ke: this.computeHariRawatKe(),
        dpjp_user_id: this.prefillDpjpUserId()
      };
      // Copy carry-over fields dari monitoring hari sebelumnya (jika ada)
      const prev = this.previousDayRecord();
      if (prev) {
        payload.konsulen = prev.konsulen || null;
        payload.smf_terkait = prev.smf_terkait || null;
        if (Array.isArray(prev.smf_terkait_ids) && prev.smf_terkait_ids.length) {
          payload.smf_terkait_ids = prev.smf_terkait_ids.map(Number).filter(Boolean);
        }
        payload.tinggi_badan = prev.tinggi_badan != null ? prev.tinggi_badan : null;
        payload.berat_badan = prev.berat_badan != null ? prev.berat_badan : null;
        payload.perawat_pja_user_id = prev.perawat_pja_user_id || null;
        if (Array.isArray(prev.alat_invasif) && prev.alat_invasif.length > 0) {
          // Copy alat + increment hari_ke
          payload.alat_invasif = prev.alat_invasif.map((a: any) => ({
            jenis: a.jenis,
            ukuran: a.ukuran,
            lokasi: a.lokasi,
            tgl_pasang: this.tglPasangOnly(a.tgl_pasang),
            hari_ke: a.hari_ke ? Number(a.hari_ke) + 1 : null
          }));
        }
        // BC Sebelumnya ambil dari bc_kumulatif hari sebelumnya
        if (prev.balance_cairan && prev.balance_cairan.bc_kumulatif != null) {
          payload.balance_cairan = {
            masuk: {
              enteral: null,
              parenteral: null,
              ngt: null,
              line_1: null,
              line_2: null,
              line_3: null,
              line_4: null,
              total: null
            },
            keluar: {
              urine: null,
              ngt: null,
              lokea: null,
              muntah: null,
              drain: null,
              uf: null,
              fungsi: null,
              bab: null,
              iwl: null,
              total: null
            },
            bc_24jam: null,
            bc_sebelumnya: prev.balance_cairan.bc_kumulatif,
            bc_kumulatif: prev.balance_cairan.bc_kumulatif
          };
        }
        // Copy nutrisi (kalori/protein/lipid/jenis jarang berubah harian)
        if (prev.nutrisi) {
          payload.nutrisi = { ...prev.nutrisi };
        }
      }
      const dxSrc = this.latestPriorDiagnosisSource(this.selectedDate);
      if (dxSrc) {
        payload.diagnosis = [...dxSrc.diagnosis];
      }

      await this.ensureEncounterLoaded();
      const raber = this.raberDoctorIds();
      if (raber.length) {
        const ids: number[] = Array.isArray(payload.smf_terkait_ids)
          ? payload.smf_terkait_ids
          : [];
        for (const id of raber) {
          if (ids.indexOf(id) === -1) ids.push(id);
        }
        payload.smf_terkait_ids = ids;
        const nama = this.namaSmf(ids);
        if (nama) payload.smf_terkait = nama;
      }
      const resp = await Monitoring24JamIcuSvc.create(payload);
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay(
          prev
            ? "Form dibuat (data carry-over dari hari sebelumnya)"
            : "Form berhasil dibuat"
        );
        await this.loadAll();
      }
    } finally {
      this.loading = false;
    }
  }

  /**
   * Register dari store jika prop bertipe primitif (number/string).
   * Parent halaman biasanya meneruskan register_id saja, detail object ada di RegisterKunjungan store.
   */
  get registerDetail(): any {
    const propReg =
      this.register && typeof this.register === "object" ? this.register : null;
    const storeReg: any = RegisterKunjungan.register;
    // Prop bisa berupa objek minimal tanpa jurnal_ranap — pakai store bila
    // store punya detail lebih lengkap untuk register yang sama
    if (propReg && !Array.isArray(propReg.jurnal_ranap) && storeReg) {
      return storeReg;
    }
    return propReg || storeReg;
  }

  get unitId() {
    const r = this.registerDetail;
    if (!r) return null;
    const j = r.jurnal_ranap;
    if (Array.isArray(j) && j.length > 0) {
      const last = j[j.length - 1];
      if (last && last.unit && last.unit.id) return last.unit.id;
    }
    // Fallback: kolom unit register (kode bangsal saat ini di cm_reg__)
    return r.unit || null;
  }

  /** Nama unit untuk display bila record belum menyimpan unit_id */
  get unitLabel(): string {
    const r = this.registerDetail;
    if (r) {
      const j = r.jurnal_ranap;
      if (Array.isArray(j) && j.length > 0) {
        const last = j[j.length - 1];
        if (last && last.unit && last.unit.name) return last.unit.name;
      }
    }
    return this.unitId ? String(this.unitId) : "-";
  }

  /** Tanggal masuk ranap dari jurnal_ranap terakhir (fallback: tgl register) */
  get tglMasukRanap(): string | null {
    const r = this.registerDetail;
    if (!r) return null;
    const j = r.jurnal_ranap;
    if (Array.isArray(j) && j.length > 0) {
      const last = j[j.length - 1];
      if (last && last.tgl_in) return last.tgl_in;
    }
    return r.tgl || null;
  }

  /** Hitung hari rawat ke- berdasarkan tanggal masuk vs selectedDate */
  computeHariRawatKe(): number | null {
    const tglIn = this.tglMasukRanap;
    if (!tglIn || !this.selectedDate) return null;
    // tgl register bisa berformat DD-MM-YYYY — parse eksplisit agar tidak null
    const d1 = moment(tglIn, ["YYYY-MM-DD", "DD-MM-YYYY"]).startOf("day");
    if (!d1.isValid()) return null;
    const d2 = moment(this.selectedDate).startOf("day");
    const diff = d2.diff(d1, "days");
    return diff >= 0 ? diff + 1 : null;
  }

  /** DPJP dari register (admission data) */
  prefillDpjpUserId(): number | null {
    const r = this.registerDetail;
    if (r && r.dokter && r.dokter.id) {
      return r.dokter.id;
    }
    return null;
  }

  /** Cari monitoring tanggal sebelumnya (terdekat sebelum selectedDate) */
  previousDayRecord(): any {
    if (!Array.isArray(this.list) || this.list.length === 0) return null;
    const target = moment(this.selectedDate).startOf("day");
    const prior = this.list
      .filter((it: any) => moment(it.tanggal).startOf("day").isBefore(target))
      .sort((a: any, b: any) =>
        moment(b.tanggal).valueOf() - moment(a.tanggal).valueOf()
      );
    return prior.length > 0 ? prior[0] : null;
  }

  latestPriorDiagnosisSource(
    refDate: string
  ): { diagnosis: string[]; tanggal: string } | null {
    if (!Array.isArray(this.list) || this.list.length === 0) return null;
    const target = moment(refDate).startOf("day");
    const prior = this.list
      .filter((it: any) => moment(it.tanggal).startOf("day").isBefore(target))
      .sort(
        (a: any, b: any) => moment(b.tanggal).valueOf() - moment(a.tanggal).valueOf()
      );
    for (const it of prior) {
      const dx = (Array.isArray(it.diagnosis) ? it.diagnosis : [])
        .map((v: string) => (v || "").trim())
        .filter((v: string) => v);
      if (dx.length) return { diagnosis: dx.slice(0, 8), tanggal: it.tanggal };
    }
    return null;
  }

  tglPasangOnly(v: any): string | null {
    if (!v) return null;
    return String(v).substring(0, 10);
  }

  async reloadCurrent() {
    if (!this.current) return;
    await storeMonitoring24JamIcu.refresh(this.current.id);
    this.syncHeaderFromCurrent();
  }

  // ================= HEADER SYNC =================

  syncHeaderFromCurrent() {
    if (!this.current) {
      this.header = this.defaultHeader();
      this.diagnosisArr = ["", "", "", "", "", "", "", ""];
      this.diagnosisPrefillDari = null;
      return;
    }
    const c = this.current;
    const defaults = this.defaultHeader();
    // Fallback prefill untuk field wajib yang masih null di record lama
    const hariRawatFallback =
      c.hari_rawat_ke || this.computeHariRawatKe() || null;
    const dpjpFallback = c.dpjp_user_id || this.prefillDpjpUserId() || null;
    this.header = {
      hari_rawat_ke: hariRawatFallback,
      tinggi_badan: c.tinggi_badan != null ? Number(c.tinggi_badan) : null,
      berat_badan: c.berat_badan != null ? Number(c.berat_badan) : null,
      dpjp_user_id: dpjpFallback,
      konsulen: c.konsulen || "",
      smf_terkait: c.smf_terkait || "",
      smf_terkait_ids: Array.isArray(c.smf_terkait_ids) ? c.smf_terkait_ids : [],
      perawat_pja_user_id: c.perawat_pja_user_id || null,
      perawat_pagi_user_id: c.perawat_pagi_user_id || null,
      perawat_sore_user_id: c.perawat_sore_user_id || null,
      perawat_malam_user_id: c.perawat_malam_user_id || null,
      gcs: { ...defaults.gcs, ...(c.gcs || {}) },
      alat_invasif: Array.isArray(c.alat_invasif)
        ? c.alat_invasif.map((a: any) => ({
            ...a,
            tgl_pasang: this.tglPasangOnly(a.tgl_pasang)
          }))
        : [],
      kondisi_luka: Array.isArray(c.kondisi_luka) ? [...c.kondisi_luka] : [],
      comfort_scale: { ...defaults.comfort_scale, ...(c.comfort_scale || {}) },
      braden_scale: { ...defaults.braden_scale, ...(c.braden_scale || {}) },
      risiko_jatuh: { ...defaults.risiko_jatuh, ...(c.risiko_jatuh || {}) },
      balance_cairan: this.mergeBalance(c.balance_cairan),
      nutrisi: { ...defaults.nutrisi, ...(c.nutrisi || {}) },
      cppt_soap: c.cppt_soap || ""
    };

    if (!(c.comfort_scale && c.comfort_scale.sedasi)) {
      this.header.comfort_scale.sedasi = this.adaNilaiComfort(c)
        ? "dengan"
        : "tanpa";
    }
    let dx: string[] = [];
    if (Array.isArray(c.diagnosis) && c.diagnosis.length > 0) {
      dx = c.diagnosis.map(function (d: string) {
        return d || "";
      });
    }
    this.diagnosisPrefillDari = null;
    if (!dx.some(v => (v || "").trim())) {
      const src = this.latestPriorDiagnosisSource(c.tanggal);
      if (src) {
        dx = [...src.diagnosis];
        this.diagnosisPrefillDari = src.tanggal;
      }
    }
    if (dx.length === 0) dx = [""];
    this.diagnosisArr = dx;
  }

  adaNilaiComfort(c: any): boolean {
    const obj = c && c.comfort_scale;
    if (!obj) return false;
    return Object.keys(obj).some((k: string) => {
      if (k === "sedasi") return false;
      const v = obj[k];
      return v !== null && v !== undefined && v !== "";
    });
  }

  mergeBalance(src: any) {
    const d = this.defaultHeader().balance_cairan;
    if (!src) return d;
    return {
      masuk: { ...d.masuk, ...(src.masuk || {}) },
      keluar: { ...d.keluar, ...(src.keluar || {}) },
      bc_24jam: src.bc_24jam ?? null,
      bc_sebelumnya: src.bc_sebelumnya ?? null,
      bc_kumulatif: src.bc_kumulatif ?? null
    };
  }

  defaultHeader() {
    return {
      hari_rawat_ke: null,
      tinggi_badan: null,
      berat_badan: null,
      dpjp_user_id: null,
      konsulen: "",
      smf_terkait: "",
      smf_terkait_ids: [],
      perawat_pja_user_id: null,
      perawat_pagi_user_id: null,
      perawat_sore_user_id: null,
      perawat_malam_user_id: null,
      gcs: {
        pagi: { e: null, v: null, m: null, total: null },
        sore: { e: null, v: null, m: null, total: null },
        malam: { e: null, v: null, m: null, total: null }
      },
      alat_invasif: [],
      kondisi_luka: [],
      comfort_scale: {
        sedasi: "tanpa",
        kewaspadaan: null,
        ketenangan: null,
        distres_pernafasan: null,
        menangis: null,
        gerakan: null,
        tonus_otot: null,
        tegangan_wajah: null,
        tekanan_darah_basal: null,
        denyut_jantung_basal: null,
        total: null
      },
      braden_scale: {
        persepsi: null,
        kelembaban: null,
        aktivitas: null,
        mobilitas: null,
        nutrisi: null,
        gesekan: null,
        total: null
      },
      risiko_jatuh: {
        riwayat: null,
        kondisi: null,
        bantuan_ambulansi: null,
        terapi_iv: null,
        gaya_berjalan: null,
        status_mental: null,
        total: null
      },
      balance_cairan: {
        masuk: {
          enteral: null,
          parenteral: null,
          ngt: null,
          line_1: null,
          line_2: null,
          line_3: null,
          line_4: null,
          total: null
        },
        keluar: {
          urine: null,
          bab: null,
          drain: null,
          iwl: null,
          total: null
        },
        bc_24jam: null,
        bc_sebelumnya: null,
        bc_kumulatif: null
      },
      nutrisi: { kalori: null, protein: null, lipid: null, jenis: null },
      cppt_soap: ""
    };
  }

  // ================= GRID HELPERS =================

  pad2(n: number) {
    return String(n).padStart(2, "0");
  }

  // KRI-094: tandai merah nilai kritis pada status penting (vital sign)
  isCritical(field: string, value: any): boolean {
    if (value === "" || value === null || value === undefined) return false;
    if (field === "kesadaran") {
      return ["Sopor", "Koma"].indexOf(String(value)) !== -1;
    }
    const n = parseFloat(value);
    if (isNaN(n)) return false;
    switch (field) {
      case "map":
        return n < 60 || n > 120;
      case "td_sistole":
        return n < 90 || n > 180;
      case "td_diastole":
        return n < 50 || n > 110;
      case "hr":
        return n < 50 || n > 130;
      case "temp":
        return n < 35 || n > 39;
      case "spo2":
        return n < 90;
      default:
        return false;
    }
  }

  entriesForSection(params: any[]): any[] {
    return this.sortedHourly.filter((h: any) => {
      const hasSectionData = params.some(
        (p: any) => this.cellValue(h, p.field) !== ""
      );
      // Fallback: entri tanpa data sama sekali tetap tampil di semua grid
      // agar tidak orphan (masih bisa diklik untuk edit/hapus)
      return hasSectionData || this.isEmptyEntry(h);
    });
  }

  isEmptyEntry(h: any): boolean {
    const all = [
      ...this.hemoParams,
      ...this.respParams,
      ...this.neuroParams,
      ...this.neuroGcsParams
    ];
    return all.every((p: any) => this.cellValue(h, p.field) === "");
  }

  shiftMinutes(h: any): number {
    // Hari form mulai 06:00 (mengikuti blanko kertas 06:00 – 05:00)
    return (((h.jam - 6) + 24) % 24) * 60 + (h.menit || 0);
  }

  waktuLabel(h: any): string {
    return this.pad2(h.jam) + ":" + this.pad2(h.menit || 0);
  }

  cellValue(h: any, field: string) {
    const v = h[field];
    return v === null || v === undefined ? "" : v;
  }

  cellDisplay(h: any, field: string) {
    const v = this.cellValue(h, field);
    if (field === "skor_nyeri" && v !== "" && h.nyeri_metode) {
      return `${v} (${String(h.nyeri_metode).toUpperCase()})`;
    }
    return v;
  }

  addHourly() {
    if (this.readOnly) return;
    this.editingHourly = null;
    this.dlgHourly = true;
  }

  editHourly(h: any) {
    this.editingHourly = h;
    this.dlgHourly = true;
  }

  // ================= BALANCE CAIRAN =================

  distinctJalur(entries: any[]): string[] {
    const out: string[] = [];
    for (const e of entries) {
      if (out.indexOf(e.jalur) === -1) out.push(e.jalur);
    }
    return out;
  }

  sumJumlah(entries: any[]): number {
    return entries.reduce((s: number, e: any) => s + (Number(e.jumlah) || 0), 0);
  }

  legacyBalanceText(arah: string): string {
    const bc = (this.current && this.current.balance_cairan) || {};
    const items: any = arah === "keluar" ? this.keluarItems : this.masukItems;
    const obj = (bc as any)[arah] || {};
    const parts: string[] = [];
    for (const k of Object.keys(items)) {
      if (obj[k] !== null && obj[k] !== undefined && obj[k] !== "") {
        parts.push(`${items[k]}: ${obj[k]}`);
      }
    }
    return parts.join("; ");
  }

  addBalance(arah: string) {
    if (this.readOnly) return;
    const now = new Date();
    this.editingBalance = null;
    this.jalurSearch = "";
    this.jenisCairanSearch = "";
    this.balanceForm = {
      arah,
      waktu: this.pad2(now.getHours()) + ":" + this.pad2(now.getMinutes()),
      jalur: null,
      jenis_cairan: null,
      jumlah: null
    };
    this.dlgBalance = true;
  }

  editBalanceEntry(entry: any) {
    if (!entry || !entry.id) return;
    this.editingBalance = entry;
    this.jalurSearch = "";
    this.jenisCairanSearch = "";
    this.balanceForm = {
      arah: entry.arah,
      waktu: this.waktuLabel(entry),
      jalur: entry.jalur,
      jenis_cairan: entry.jenis_cairan || null,
      jumlah: entry.jumlah
    };
    this.dlgBalance = true;
  }

  async simpanBalance() {
    if (!this.current) return;
    // Combobox Vuetify 2 baru commit teks saat blur/Enter — pakai shadow search
    const jalur = String(this.balanceForm.jalur || this.jalurSearch || "").trim();
    if (!this.balanceForm.waktu) {
      appModule.NoticeDelay("Waktu harus diisi");
      return;
    }
    if (!jalur) {
      appModule.NoticeDelay("Jalur / Line harus diisi");
      return;
    }
    const jumlah = Number(this.balanceForm.jumlah);
    if (this.balanceForm.jumlah === null || this.balanceForm.jumlah === "" || isNaN(jumlah)) {
      appModule.NoticeDelay("Jumlah (cc) harus diisi");
      return;
    }
    const jenisCairan = String(
      this.balanceForm.jenis_cairan || this.jenisCairanSearch || ""
    ).trim();
    const [jam, menit] = String(this.balanceForm.waktu)
      .split(":")
      .map(Number);
    // Payload eksplisit — jangan kirim field server-managed (petugas dkk)
    const payload: any = {
      arah: this.balanceForm.arah,
      jalur: jalur.substring(0, 100),
      jenis_cairan: jenisCairan ? jenisCairan.substring(0, 100) : null,
      jam,
      menit,
      jumlah
    };
    if (this.editingBalance && this.editingBalance.id) {
      payload.balance_id = this.editingBalance.id;
    } else {
      // Anti-duplikat: entri identik arah+jalur+jenis+waktu → timpa entri
      // tsb. Jenis ikut dibandingkan — satu jalur boleh berisi beberapa
      // jenis cairan pada jam yang sama
      const dup = this.sortedBalance.find(
        (e: any) =>
          e.arah === payload.arah &&
          e.jalur === payload.jalur &&
          String(e.jenis_cairan || "") === String(payload.jenis_cairan || "") &&
          e.jam === jam &&
          (e.menit || 0) === (menit || 0)
      );
      if (dup) payload.balance_id = dup.id;
    }
    this.savingBalance = true;
    try {
      const resp = await Monitoring24JamIcuSvc.upsertBalance(
        this.current.id,
        payload
      );
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay("Entri balance cairan tersimpan");
        this.dlgBalance = false;
        await this.reloadCurrent();
      }
    } finally {
      this.savingBalance = false;
    }
  }

  async hapusBalance() {
    if (!this.current || !this.editingBalance) return;
    const label = `${this.editingBalance.jalur} ${this.waktuLabel(this.editingBalance)}`;
    if (!confirm(`Hapus entri ${label}?`)) return;
    this.deletingBalance = true;
    try {
      const resp = await Monitoring24JamIcuSvc.deleteBalance(
        this.current.id,
        this.editingBalance.id
      );
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay("Entri balance cairan dihapus");
        this.dlgBalance = false;
        await this.reloadCurrent();
      }
    } finally {
      this.deletingBalance = false;
    }
  }

  // ================= OBAT =================
  jamPemberianAll(): string[] {
    const semua = this.jamPemberianChips.slice();
    if (this.jamPemberianInput) semua.push(this.jamPemberianInput);
    return semua.filter(
      (j: string, i: number) => !!j && semua.indexOf(j) === i
    );
  }

  tambahJamPemberian() {
    const jam = this.jamPemberianInput;
    if (!jam) return;
    if (this.jamPemberianChips.indexOf(jam) < 0) {
      this.jamPemberianChips.push(jam);
    }
    this.jamPemberianInput = "";
  }

  hapusJamPemberian(index: number) {
    this.jamPemberianChips.splice(index, 1);
  }

  deriveKategoriObat(caraPemberian: any): string {
    const cara = String(caraPemberian || "").toLowerCase().trim();
    if (!cara) return "lain";

    const injeksi = [
      "iv", "i.v", "intravena", "intra vena", "im", "i.m", "intramuskular",
      "intramuskuler", "sc", "s.c", "subkutan", "sub kutan", "ic", "intrakutan",
      "drip", "infus", "infuse", "bolus", "syringe pump", "syringepump",
      "injeksi", "inj", "parenteral", "epidural", "intratekal"
    ];
    if (injeksi.some(k => cara.indexOf(k) !== -1)) return "injeksi";

    const oral = [
      "po", "p.o", "per oral", "peroral", "oral", "ngt", "og", "sonde",
      "enteral", "sublingual", "bukal", "buccal"
    ];
    if (oral.some(k => cara.indexOf(k) !== -1)) return "oral";

    return "lain";
  }

  get obatRows(): any[] {
    const rank: any = { injeksi: 1, oral: 2, lain: 3 };
    const label: any = {
      injeksi: "Injeksi / Parenteral",
      oral: "Oral / Enteral",
      lain: "Lain-lain"
    };
    const rows = (this.current && this.current.obat) || [];
    return rows.map((o: any, i: number) => {
      const kategori = rank[o.kategori]
        ? o.kategori
        : this.deriveKategoriObat(o.cara_pemberian);
      return {
        ...o,
        _no: i + 1,
        kategori,
        _kategoriUrut: `${rank[kategori] || 9}|${label[kategori] || label.lain}`
      };
    });
  }

  obatRowClass(item: any): string {
    if (item.ham_lasa === "1" || item.ham_lasa === 1) return "red-row";
    if (item.ham_lasa === "2" || item.ham_lasa === 2) return "yellow-row";
    return "";
  }

  onObatNamaInput(text: string) {
    if (text !== this.obatForm.nama_obat) {
      this.$set(this.obatForm, "ham_lasa", null);
    }
    this.$set(this.obatForm, "nama_obat", text);
  }

  onObatPick(item: any) {
    const hl = item ? String(item.ham_lasa || "") : "";
    this.$set(
      this.obatForm,
      "ham_lasa",
      hl === "1" || hl === "2" ? hl : null
    );
  }

  labelKategoriObat(group: any): string {
    const parts = String(group || "").split("|");
    return parts.length > 1 ? parts[1] : String(group || "");
  }

  onCaraPemberianChange(val: any) {
    this.$set(this.obatForm, "kategori", this.deriveKategoriObat(val));
  }

  editObat(item: any) {
    this.editingObat = item;
    this.obatForm = item
      ? {
          ...item,
          kategori: item.kategori || this.deriveKategoriObat(item.cara_pemberian)
        }
      : {
          nama_obat: "",
          ham_lasa: null,
          dosis: "",
          cara_pemberian: "",
          jam_pemberian: "",
          kategori: "injeksi",
          cc_jam: "",
          tgl_mulai: null,
          tgl_stop: null,
          keterangan: ""
        };

    const jam = String(this.obatForm.jam_pemberian || "")
      .split(",")
      .map((s: string) => s.trim())
      .filter((s: string) => !!s);
    this.jamPemberianInput = jam.length ? jam[jam.length - 1] : "";
    this.jamPemberianChips = jam.slice(0, -1);

    this.dlgObat = true;
  }

  async simpanObat() {
    if (!this.current) return;
    if (!this.obatForm.nama_obat) {
      appModule.NoticeDelay("Nama obat harus diisi");
      return;
    }
    this.obatForm.jam_pemberian = this.jamPemberianAll().join(", ");
    this.savingObat = true;
    try {
      let resp;
      if (this.editingObat && this.editingObat.id) {
        resp = await Monitoring24JamIcuSvc.updateObat(
          this.current.id,
          this.editingObat.id,
          this.obatForm
        );
      } else {
        resp = await Monitoring24JamIcuSvc.addObat(
          this.current.id,
          this.obatForm
        );
      }
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay("Obat tersimpan");
        this.dlgObat = false;
        await this.reloadCurrent();
      }
    } finally {
      this.savingObat = false;
    }
  }

  async tarikObatCpo() {
    if (this.readOnly || !this.current) return;
    this.importingObat = true;
    try {
      const resp = await Monitoring24JamIcuSvc.importObatFromCpo(this.current.id);
      if (resp && resp.data) {
        appModule.NoticeDelay(resp.data.message || "Selesai menarik obat");
        if (resp.data.imported > 0) {
          await this.reloadCurrent();
        }
      }
    } finally {
      this.importingObat = false;
    }
  }

  async hapusObat(item: any) {
    if (this.readOnly) return;
    if (!this.current) return;
    if (!confirm(`Hapus obat ${item.nama_obat}?`)) return;
    const resp = await Monitoring24JamIcuSvc.deleteObat(
      this.current.id,
      item.id
    );
    if (resp && resp.data && resp.data.status === "1") {
      appModule.NoticeDelay("Obat dihapus");
      await this.reloadCurrent();
    }
  }

  // ================= INSTRUKSI =================

  editInstruksi(item: any) {
    this.editingInstruksi = item;
    this.instruksiForm = item
      ? { ...item }
      : { instruksi: "", jam: null, hasil: "" };
    this.dlgInstruksi = true;
  }

  async simpanInstruksi() {
    if (!this.current) return;
    if (!this.instruksiForm.instruksi) {
      appModule.NoticeDelay("Instruksi harus diisi");
      return;
    }
    this.savingInstruksi = true;
    try {
      let resp;
      if (this.editingInstruksi && this.editingInstruksi.id) {
        resp = await Monitoring24JamIcuSvc.updateInstruksi(
          this.current.id,
          this.editingInstruksi.id,
          this.instruksiForm
        );
      } else {
        resp = await Monitoring24JamIcuSvc.addInstruksi(
          this.current.id,
          this.instruksiForm
        );
      }
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay("Instruksi tersimpan");
        this.dlgInstruksi = false;
        await this.reloadCurrent();
      }
    } finally {
      this.savingInstruksi = false;
    }
  }

  async hapusInstruksi(item: any) {
    if (!this.current) return;
    if (!confirm("Hapus instruksi ini?")) return;
    const resp = await Monitoring24JamIcuSvc.deleteInstruksi(
      this.current.id,
      item.id
    );
    if (resp && resp.data && resp.data.status === "1") {
      appModule.NoticeDelay("Instruksi dihapus");
      await this.reloadCurrent();
    }
  }

  // ================= AUTO-CALC =================

  // KRI-087: Kesadaran auto-derive dari GCS total (15=CM, 13-14=Apatis, 11-12=Somnolen, 9-10=Sopor, <=8=Koma)
  kesadaranFromGcs(total: number | string | null): string | null {
    if (total === GCS_NT) return "Tidak dapat dinilai (NT)";
    if (!total) return null;
    const n = Number(total);
    if (isNaN(n)) return null;
    if (n >= 15) return "CM";
    if (n >= 13) return "Apatis";
    if (n >= 11) return "Somnolen";
    if (n >= 9) return "Sopor";
    return "Koma";
  }

  get hasLegacyHeaderGcs(): boolean {
    const gcs = this.header.gcs || {};
    return ["pagi", "sore", "malam"].some((slot: string) => {
      const g = (gcs as any)[slot];
      if (!g) return false;
      return [g.e, g.v, g.m, g.total].some(
        (v: any) => v !== null && v !== undefined && v !== ""
      );
    });
  }

  get isDenganSedasi(): boolean {
    return this.header.comfort_scale.sedasi === "dengan";
  }

  get effectiveComfortTotal() {
    if (!this.isDenganSedasi) return null;
    const t = this.header.comfort_scale.total;
    return t === undefined ? null : t;
  }

  onSedasiChange() {
    this.header = { ...this.header };
  }

  get comfortInterpretasi() {
    const t = this.header.comfort_scale.total;
    if (t === null || t === undefined || t === "") {
      return null;
    }
    const n = Number(t);
    if (n < 17) {
      return { text: "Sedasi terlalu dalam", color: "red" };
    }
    if (n > 26) {
      return { text: "Sedasi tidak optimal", color: "orange darken-3" };
    }
    return { text: "Sedasi optimal", color: "green darken-2" };
  }

  recalcComfort() {
    const cs = this.header.comfort_scale;
    const keys = Object.keys(this.comfortItems);
    let sum = 0;
    let anyFilled = false;
    for (const k of keys) {
      if (cs[k] !== null && cs[k] !== undefined) {
        sum += Number(cs[k]) || 0;
        anyFilled = true;
      }
    }
    cs.total = anyFilled ? sum : null;
    this.header = { ...this.header };
  }

  recalcBraden() {
    const br = this.header.braden_scale;
    const keys = Object.keys(this.bradenItems);
    let sum = 0;
    let anyFilled = false;
    for (const k of keys) {
      if (br[k] !== null && br[k] !== undefined) {
        sum += Number(br[k]) || 0;
        anyFilled = true;
      }
    }
    br.total = anyFilled ? sum : null;
    this.header = { ...this.header };
  }

  recalcMorse() {
    const rj = this.header.risiko_jatuh;
    const keys = Object.keys(this.morseItems);
    let sum = 0;
    let anyFilled = false;
    for (const k of keys) {
      if (rj[k] !== null && rj[k] !== undefined) {
        sum += Number(rj[k]) || 0;
        anyFilled = true;
      }
    }
    rj.total = anyFilled ? sum : null;
    this.header = { ...this.header };
  }

  // ================= DIAGNOSIS SYNC =================

  syncDiagnosis() {
    // empties di-strip saat simpan (lihat simpanHeader)
  }

  get formatTanggalSumberDx(): string {
    if (!this.diagnosisPrefillDari) return "";
    return moment(this.diagnosisPrefillDari).format("DD-MM-YYYY");
  }

  addDiagnosis() {
    if (this.diagnosisArr.length >= 8) {
      appModule.NoticeDelay("Maksimal 8 baris diagnosis (sesuai blanko/cetakan)");
      return;
    }
    this.diagnosisArr.push("");
  }

  removeDiagnosis(i: number) {
    this.diagnosisArr.splice(i, 1);
    if (this.diagnosisArr.length === 0) this.diagnosisArr.push("");
  }

  // ================= SIMPAN HEADER =================

  async simpanHeader() {
    if (!this.current) return;
    this.saving = true;
    try {
      const diagnosis = this.diagnosisArr
        .map(s => (s || "").trim())
        .filter(s => s);
      const payload = {
        ...this.header,
        register_id: this.current.register_id,
        pasien_rm: this.current.pasien_rm,
        tanggal: this.current.tanggal,
        // Backfill unit_id untuk record lama yang tersimpan tanpa unit
        unit_id: this.current.unit_id || this.unitId || null,
        diagnosis
      };
      const resp = await Monitoring24JamIcuSvc.updateHeader(
        this.current.id,
        payload
      );
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay("Header tersimpan");
        await this.reloadCurrent();
      }
    } finally {
      this.saving = false;
    }
  }

  // ================= VERIFY DPJP =================

  async toggleVerifyDpjp() {
    if (!this.current || this.verifikasiTerkunci) return;
    this.verifying = true;
    try {
      const resp = this.current.dpjp_verified
        ? await Monitoring24JamIcuSvc.unverifyDpjp(this.current.id)
        : await Monitoring24JamIcuSvc.verifyDpjp(this.current.id);
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay(
          this.current.dpjp_verified
            ? "Verifikasi dibatalkan"
            : "Terverifikasi DPJP"
        );
        await this.reloadCurrent();
      }
    } finally {
      this.verifying = false;
    }
  }

  konfirmasiHapusForm() {
    if (!this.canEditForm || !this.current || this.current.dpjp_verified)
      return;
    const tanggal = this.formatDateChip(this.current.tanggal);
    this.msgHapusForm = `Hapus Monitoring 24 Jam tanggal ${tanggal} beserta seluruh isian jam, balance cairan, obat, dan instruksinya`;
    this.dlgHapusForm = true;
  }

  async hapusForm() {
    if (!this.canEditForm || !this.current || this.current.dpjp_verified)
      return;
    this.deletingForm = true;
    try {
      const resp = await Monitoring24JamIcuSvc.destroy(this.current.id);
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay("Monitoring 24 jam dihapus");
        await this.loadAll();
      }
    } finally {
      this.deletingForm = false;
    }
  }

  // ================= PRINT PDF =================

  printPdf() {
    if (!this.current) return;
    Monitoring24JamIcuSvc.printPdf(this.current.id);
  }

  // ================= UTIL =================

  formatDateChip(d: string) {
    return moment(d).format("DD-MM-YY");
  }
}
